module.exports = __webpack_public_path__ + "static/00043.5d3fcd1e.jpg";